// Task #4705 — "Booking Form Not Completed (before auto-approval deadline)"
// messaging-rule trigger. A booking request on PadSplit auto-approves after a
// per-property window (24h default, 48h option — must match the host's
// PadSplit setting). This trigger schedules a follow-up reminder that lands
// BEFORE that deadline so the member still has time to complete the booking
// form. Shared by the server scheduler/dispatcher, the rule-form validation
// (schema superRefine), and the client rule UI.

export const BOOKING_FORM_FOLLOWUP_TRIGGER = "booking_form_followup";

// Allowed per-property auto-approval windows (hours). PadSplit only offers
// these two settings, so PadPulse mirrors them exactly.
export const AUTO_APPROVAL_WINDOW_HOURS_OPTIONS = [24, 48] as const;
export const DEFAULT_AUTO_APPROVAL_WINDOW_HOURS = 24;

// How far ahead of the auto-approval deadline the follow-up is sent.
export const BOOKING_FORM_FOLLOWUP_LEAD_HOURS = 2;

/**
 * Compute the follow-up send time: booking-request arrival + auto-approval
 * window − 2h lead. Returns the Date unconditionally — callers must skip
 * scheduling when the result is not after "now" (e.g. a stale request that
 * surfaced with less than 2h left in its window).
 */
export function computeBookingFormFollowupSendAt(
  arrivedAt: Date,
  windowHours: number,
): Date {
  const hours = windowHours > 0 ? windowHours : DEFAULT_AUTO_APPROVAL_WINDOW_HOURS;
  return new Date(
    arrivedAt.getTime() + (hours - BOOKING_FORM_FOLLOWUP_LEAD_HOURS) * 60 * 60 * 1000,
  );
}

// Error copy for the HARD server-side requirement: unlike New Booking rules
// (where the link is optional with a confirm dialog), an ENABLED rule on this
// trigger is useless without the booking-form link — the whole point is to
// re-send the form before the deadline.
export const BOOKING_FORM_FOLLOWUP_LINK_REQUIRED_ERROR =
  "Booking Form Not Completed rules must include a booking request link ({{booking_request_link}}) so the member can complete the form before the auto-approval deadline.";
